import { render, staticRenderFns } from "./FacilityBox.vue?vue&type=template&id=7551c2c6&scoped=true"
import script from "./FacilityBox.vue?vue&type=script&lang=js"
export * from "./FacilityBox.vue?vue&type=script&lang=js"
import style0 from "./FacilityBox.vue?vue&type=style&index=0&id=7551c2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7551c2c6",
  null
  
)

export default component.exports